// extracted by mini-css-extract-plugin
module.exports = {"field":"EditLabelModal_field__1loGL","input":"EditLabelModal_input__DUW2n","label":"EditLabelModal_label__1Pppa"};